/** GPUParticlesCollisionSphere3D draws only its editor gizmo, so the badge reads "not implemented". */
import { nodeComponentRegistry } from '../../../../../r3f/NodeComponentRegistry';
import { sphereVolumeNode } from '../../volume/volumeNode';
nodeComponentRegistry.register({
    typeName: 'GPUParticlesCollisionSphere3D',
    Component: sphereVolumeNode('collision'),
    renderIntent: 'pending',
});
//# sourceMappingURL=index.r3f.js.map